import React,{useEffect,useState} from 'react'
import dayjs from 'dayjs'
import { DatePicker, Space, Table } from 'antd';
import cubejs from "@cubejs-client/core";
import { handlePersonQueryOnboard,handlePersonProspectQuery,hanldlePersonCaseQuery} from './utils';
import { Radio } from 'antd';
const column = [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        width:200,
        fixed: 'left',
      },
      {
        title: 'Prospect',
        dataIndex: 'pros_count',
        key: 'pros_count',
        width:100,
        fixed: 'left',
      },
      

  ];

function PersonWise({ onChange,startDate,endDate,fillMissingDatesWithZeroCount,formatDate,accessLevel,getPreiviousDate,dateMonthRadio,transformData, onWeeklyChange}) {

    const [onboardCount,setOnboardCount]=useState([])
    const [prospectCount,setProspectCount]=useState([])
    const [data,setData]=useState([])
    const [columns,setColumns]=useState([])
    const [caseData,setCaseData]=useState([])
    const [caseCount,setCaseCount]=useState([])


    useEffect(()=>{
     if(prospectCount?.length>0){
        setData(mergeDataFormat(onboardCount,prospectCount))
     }
    },[onboardCount,prospectCount])


    useEffect(()=>{
        if(prospectCount?.length>0){
           setCaseData(mergeDataFormat(caseCount,prospectCount))
        }
       },[caseCount,prospectCount])


    const mergeDataFormat=(data1,data2)=>{
        const map1 = new Map(data2.map(item => [item.name, item]));

        // Merge array2 into array1
        const result = data1.map(item => ({
        ...map1.get(item.name),
        ...item
        }));

        // If a name is missing from array1, add it with a 'pros_count' of 0
        data2.forEach(item => {
        if (!result.some(resultItem => resultItem.name === item.name)) {
            result.push({ ...item, onboard: [] });
        }
        });
        return result
    }


    useEffect(()=>{

        const cubejsApi = cubejs(
            process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA_TOKEN,
            {
                apiUrl: process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA,
            }
        );
        if (accessLevel ) {
            handlePersonQueryProspect(cubejsApi)
        }

    },[])

    useEffect(()=>{
        const columnsFilled=dateMonthRadio==='date'?fillMissingDatesWithZeroCount([]):transformData(fillMissingDatesWithZeroCount([]))

        const filledColumn= columnsFilled?.map(data=>{
            return {
                title: dateMonthRadio==='date'?formatDate(data?.date):data?.date,
                dataIndex: data?.date,
                key: data?.date,
                width:100
            }
        })

        setColumns([...filledColumn])


    },[startDate,endDate,dateMonthRadio])


    useEffect(()=>{

        const cubejsApi = cubejs(
            process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA_TOKEN,
            {
                apiUrl: process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA,
            }
        );
        if (accessLevel ) {
            handleOboardQueryClient(cubejsApi,dateMonthRadio)
        }

    },[startDate,endDate,dateMonthRadio])

    useEffect(()=>{

        const cubejsApi = cubejs(
            process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA_TOKEN,
            {
                apiUrl: process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA,
            }
        );
        if (accessLevel ) {
            handleCaseQueryClient(cubejsApi,dateMonthRadio)
        }

    },[startDate,endDate,dateMonthRadio])

    const formattedDateForOnboard=(modifyData)=>{
        const formatted = modifyData.reduce((acc, item) => {
            const existingItemIndex = acc.findIndex(elem => elem.name === item.name );
            if (existingItemIndex !== -1) {
              acc[existingItemIndex].onboard.push({ date: item.date, onboard_count: item.onboard_count });
            } else {
              acc.push({
                name:item?.name,
                onboard: [{ date: item.date, onboard_count: item.onboard_count }]
              });
            }
            return acc;
          }, []);

          return formatted
    }


    const handleOboardQueryClient=async(cubejsApi,dateMonthRadio)=>{

        try {
            await cubejsApi
                .load(handlePersonQueryOnboard(getPreiviousDate(startDate),endDate,dateMonthRadio))
                .then((resultSet) => {
                    
                    //    //console.log(resultSet)
                    const modifiedData = resultSet?.loadResponses[0]?.data?.map(data => {
                        return { 
                            name:data['Contribution.agent_name'],
                            date:data['Contribution.Onboarded_date']?.split('T')?.[0],
                            onboard_count:data['Contribution.client_count']
                        }
                    })
                    //console.log(modifiedData)
                    const formatedData=formattedDateForOnboard(modifiedData)
                    //console.log(formatedData)
                    setOnboardCount(formatedData)
                    
                })
                .catch((error) => {
                    console.error("Error fetching API response:", error);
                });

        } catch (err) {

        }
    }

    const handlePersonQueryProspect=async(cubejsApi)=>{

        try {
            await cubejsApi
                .load(handlePersonProspectQuery(accessLevel?.name,getPreiviousDate(startDate),endDate))
                .then((resultSet) => {
                    //    //console.log(resultSet)
                    const modifiedData = resultSet?.loadResponses[0]?.data?.map(data => {
                        return { 
                            name:data['m_dashboard.source_name'],
                            pros_count:data['m_dashboard.lead_count']
                        }
                    })

                    //console.log(modifiedData)
                    setProspectCount(modifiedData)
                    
                })
                .catch((error) => {
                    console.error("Error fetching API response:", error);
                });

        } catch (err) {

        }
    }


    const handleCaseQueryClient=async(cubejsApi,dateMonthRadio)=>{

        try {
            await cubejsApi
                .load(hanldlePersonCaseQuery(getPreiviousDate(startDate),endDate,dateMonthRadio))
                .then((resultSet) => {
                    //    //console.log(resultSet)
                    const modifiedData = resultSet?.loadResponses[0]?.data?.map(data => {
                        return { 
                            name:data['Contribution.agent_name'],
                            date:data['Contribution.Date']?.split('T')?.[0],
                            onboard_count:data['Contribution.total_case_count']
                        }
                    })
 
                    const formatedData=formattedDateForOnboard(modifiedData)
                    //console.log(formatedData)
                    setCaseCount(formatedData)
                    
                })
                .catch((error) => {
                    console.error("Error fetching API response:", error);
                });

        } catch (err) {

        }
    }

    const handleTableData=(data1)=>{
        // fillMissingDatesWithZeroCount(data1)
        const filled=data1?.map(data=>{
            if(dateMonthRadio==='date'){
                return {...data,
                onboard:fillMissingDatesWithZeroCount(data?.onboard)
                }
                }else{
                    return {...data,
                        onboard:transformData(fillMissingDatesWithZeroCount(data?.onboard))
                        } 
                }
        })

        const modFilled = filled?.map(data=>{
            return {
                name:data?.name,
                pros_count:data?.pros_count,
                onboard: data?.onboard?.reduce((total,data)=>total+parseInt(data?.onboard_count),0),
                ...handleExtractDate(data?.onboard)
            }
        })

        //console.log(modFilled)
        return modFilled
        // setData(modFilled)
    }

    const handleExtractDate=(onboardData)=>{
        const dateDate={}
        onboardData?.map(data=>{
            
              dateDate[data?.date]=data?.onboard_count
            
        })
        return dateDate
    }

    return (
        <div>
            <div>

                <div style={{ padding: '0px 30px', marginBottom:'10px'}}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                        <div style={{ fontSize: '20px', fontWeight: '700' }}>Onboard Count</div>
                        
                        <div style={{display:'flex'}}>
                    <div>
                    <Radio.Group style={{width:'200px'}} onChange={onWeeklyChange} value={dateMonthRadio}>
                        <Radio value={'date'}>By Date</Radio>
                        <Radio value={'month'}>By Month</Radio>
                        </Radio.Group>
                    </div>
                        <div> { dateMonthRadio==='date' &&
                             <DatePicker defaultValue={dayjs()} onChange={onChange} picker="month" />
                             
                        }</div>
                        </div>
                    </div>

                    <div style={{marginTop:'20px'}}>

                        <Table className='table-map-state' dataSource={handleTableData(data)?.sort((a,b)=>b?.onboard-a?.onboard)} columns={[...column,{
                                title: 'New Install',
                                dataIndex: 'onboard',
                                key: 'onboard',
                                width:110,
                                fixed: 'left',
                            },...columns]}   scroll={{
                                y: 540,
                                x:1000
                            }} pagination={false}  />

                    </div>
                </div>

                
                <div style={{ padding: '30px 30px',marginBottom:'30px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                        <div style={{ fontSize: '20px', fontWeight: '700' }}>Case Count</div>
                        <div> </div>
                    </div>

                    <div style={{marginTop:'20px'}}>

                        <Table className='table-map-state' dataSource={handleTableData(caseData)?.sort((a,b)=>b?.onboard-a?.onboard)} columns={[...column,{
                                title: 'Total Cases',
                                dataIndex: 'onboard',
                                key: 'onboard',
                                width:110,
                                fixed: 'left',
                            },...columns]}   scroll={{
                                y: 500,
                                x:1000
                            }}  pagination={false}  />

                    </div>
                </div>

            </div>

        </div>
    )
}

export default PersonWise
